import React, { useMemo, useState } from "react";
import RRChecklistReg from "../renderRows/RRChecklistReg";

import './ChecklistRegList.css';
import ChecklistRegInfo from "../checklistRegInfo/ChecklistRegInfo";
import normalizeText from "../../utils/normalizeText";
import { getChecklistRegByID, getChecklistRegFiles } from "../../api/checklist";

const ChecklistRegList = ({checklistRegList,filter}) =>{

    const [showInfo,setShowInfo] = useState(undefined);

    const ckListFiltered = useMemo(()=> checklistRegList.filter(c => {
        return (filter != '') ? 
            (filter.charAt(0) == '"' && filter.charAt(filter.length - 1) == '"') ?
                ((normalizeText(`${c.codigo} - ${c.checkNro}`) == normalizeText(filter.replaceAll('"',''))) || normalizeText(c.name) == normalizeText(filter.replaceAll('"','')) || normalizeText(c.codigo) == normalizeText(filter.replaceAll('"','')) || normalizeText(`${c.name} - ${c.nameActivo}`) == normalizeText(filter.replaceAll('"','')))
            :
                ((normalizeText(`${c.codigo} - ${c.checkNro}`).includes(normalizeText(filter))) || normalizeText(c.name).includes(normalizeText(filter)) || normalizeText(c.codigo).includes(normalizeText(filter)) || normalizeText(`${c.name} - ${c.nameActivo}`).includes(normalizeText(filter)))
        : true
    }) 
    , [checklistRegList, filter]);

    const cerrarInfo = (cerrar) =>{
        if(cerrar == null) setShowInfo(undefined);
    }

    const handleShowInfo = async(check) => {
        const resp = await getChecklistRegByID(check._id);
        let files = [];
        try {
            const prefijo = `${check.codigo}_${check.checkNro}`;
            const filesResp = await getChecklistRegFiles(prefijo);
            files = filesResp.data?.data || [];
        } catch (error) {
            console.log("Error al cargar archivos del checklist", error);
        }
        setShowInfo({ item: resp.data?.data, files });
    }

    return <div className="checklistRegListDiv">
        {ckListFiltered.map((c,i) => <RRChecklistReg check={c} setShowInfo={setShowInfo} handleShowInfo={handleShowInfo} key={`${c.codigo}-${c.checkNro}`}/>)}
        {showInfo != undefined && <div className="modalContainer">
            <ChecklistRegInfo checkInfo={showInfo.item} files={showInfo.files} cerrar={cerrarInfo}/>
        </div>}
    </div>
}

export default ChecklistRegList;